export const KEYBOARD = {
  escape: {
    code: 'Escape',
  },
  tab: {
    code: 'Tab',
  },
  space: {
    code: 'Space',
  },
  enter: {
    code: 'Enter',
  },
};
